import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-menu",
  "use": "svgIcon-menu-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-menu\"><path d=\"m24 3c0-.6-.4-1-1-1h-22c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h22c .6 0 1-.4 1-1z\" fill=\"currentColor\" /><path d=\"m24 11c0-.6-.4-1-1-1h-22c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h22c .6 0 1-.4 1-1z\" fill=\"currentColor\" /><path d=\"m24 19c0-.6-.4-1-1-1h-22c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h22c .6 0 1-.4 1-1z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol